// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill-editor-wrapper .ql-container {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #fff;
  min-height: 400px;
  font-family: inherit;
  font-size: 16px;
}
.quill-editor-wrapper .ql-toolbar {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #f8f9fa;
  border-color: #ccc;
  /* Fix for toolbar buttons and pickers alignment */
}
.quill-editor-wrapper .ql-toolbar .ql-formats {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0 !important;
}
.quill-editor-wrapper .ql-toolbar {
  /* Fix svg vertical alignment in pickers */
}
.quill-editor-wrapper .ql-toolbar .ql-picker-label svg {
  margin-top: -7px;
}
.quill-editor-wrapper .ql-editor {
  min-height: 400px;
  max-height: 600px;
  overflow-y: auto;
  overflow-wrap: break-word;
  word-break: break-word;
}
.quill-editor-wrapper .ql-editor.ql-blank {
  display: grid !important;
  align-items: start;
}
.quill-editor-wrapper .ql-editor.ql-blank::before {
  color: #9ca3af;
  font-style: normal;
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  grid-column: 1;
  grid-row: 1;
  white-space: pre-wrap;
  word-break: break-word;
  pointer-events: none;
}
.quill-editor-wrapper .ql-editor.ql-blank > * {
  grid-column: 1;
  grid-row: 1;
}
.quill-editor-wrapper {
  /* Bodhiwell Blog Typography Simulation (ONLY FOR BLOG VARIANT) */
}
.quill-editor-wrapper--blog .ql-toolbar,
.quill-editor-wrapper--blog .ql-container {
  max-width: 940px !important;
  margin: 0;
}
.quill-editor-wrapper--blog .ql-editor {
  font-family: "Sora", sans-serif !important;
  text-align: justify;
}
.quill-editor-wrapper--blog .ql-editor h2 {
  margin: 0 0 18px;
  font-size: 38px;
  line-height: 1.12;
  letter-spacing: -0.032em;
  font-weight: 700;
  color: #13231D;
}
.quill-editor-wrapper--blog .ql-editor h3 {
  margin: 28px 0 14px;
  font-size: 26px;
  line-height: 1.22;
  letter-spacing: -0.022em;
  font-weight: 700;
  color: #13231D;
}
.quill-editor-wrapper--blog .ql-editor h4 {
  margin: 24px 0 12px;
  font-size: 22px;
  line-height: 1.28;
  letter-spacing: -0.015em;
  font-weight: 700;
  color: #20362D;
}
.quill-editor-wrapper--blog .ql-editor p,
.quill-editor-wrapper--blog .ql-editor li {
  font-size: 18px;
  line-height: 1.8;
  color: #3E4B45;
}
.quill-editor-wrapper--blog .ql-editor p {
  margin: 0 0 20px;
}
.quill-editor-wrapper--blog .ql-editor ul,
.quill-editor-wrapper--blog .ql-editor ol {
  margin: 0 0 24px 1.2em;
  padding: 0;
}
.quill-editor-wrapper--blog .ql-editor li + li {
  margin-top: 10px;
}
.quill-editor-wrapper--blog .ql-editor blockquote {
  margin: 30px 0;
  padding: 26px 28px;
  border-left: 4px solid #D6A640;
  background: rgba(130, 177, 148, 0.08);
  border-radius: 20px;
}
.quill-editor-wrapper--blog .ql-editor blockquote p {
  margin: 0;
  font-size: 22px;
  line-height: 1.65;
  font-weight: 600;
  color: #20362D;
}
.quill-editor-wrapper .ql-container.ql-snow,
.quill-editor-wrapper .ql-toolbar.ql-snow {
  border: 1px solid #d1d5db;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/TextEditorUi/CustomQuillEditor.scss"],"names":[],"mappings":"AACE;EACE,+BAAA;EACA,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AAAJ;AAGE;EACE,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EAEA,kDAAA;AAFJ;AAGI;EACE,oBAAA;EACA,mBAAA;EACA,2BAAA;AADN;AATE;EAaE,0CAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAIE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAFJ;AAII;EACE,wBAAA;EACA,kBAAA;AAFN;AAKI;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;AAHN;AAMI;EACE,cAAA;EACA,WAAA;AAJN;AApDA;EA4DE,iEAAA;AALF;AAQI;;EAEE,2BAAA;EACA,SAAA;AANN;AASI;EACE,0CAAA;EACA,mBAAA;AAPN;AASM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;AAPR;AAUM;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;AARR;AAWM;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;AATR;AAYM;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;AAVR;AAaM;EACE,gBAAA;AAXR;AAcM;;EAEE,sBAAA;EACA,UAAA;AAZR;AAeM;EACE,gBAAA;AAbR;AAgBM;EACE,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,qCAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAdV;AAoBE;;EAEE,yBAAA;AAlBJ","sourcesContent":[".quill-editor-wrapper {\n  .ql-container {\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    background-color: #fff;\n    min-height: 400px;\n    font-family: inherit;\n    font-size: 16px;\n  }\n\n  .ql-toolbar {\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    background-color: #f8f9fa;\n    border-color: #ccc;\n\n    /* Fix for toolbar buttons and pickers alignment */\n    .ql-formats {\n      display: inline-flex;\n      align-items: center;\n      margin-bottom: 0 !important;\n    }\n\n    /* Fix svg vertical alignment in pickers */\n    .ql-picker-label svg {\n      margin-top: -7px;\n    }\n  }\n\n  .ql-editor {\n    min-height: 400px;\n    max-height: 600px;\n    overflow-y: auto;\n    overflow-wrap: break-word;\n    word-break: break-word;\n\n    &.ql-blank {\n      display: grid !important;\n      align-items: start;\n    }\n\n    &.ql-blank::before {\n      color: #9ca3af;\n      font-style: normal;\n      position: relative !important;\n      left: 0 !important;\n      top: 0 !important;\n      grid-column: 1;\n      grid-row: 1;\n      white-space: pre-wrap;\n      word-break: break-word;\n      pointer-events: none;\n    }\n\n    &.ql-blank>* {\n      grid-column: 1;\n      grid-row: 1;\n    }\n  }\n\n  /* Bodhiwell Blog Typography Simulation (ONLY FOR BLOG VARIANT) */\n  &--blog {\n\n    .ql-toolbar,\n    .ql-container {\n      max-width: 940px !important;\n      margin: 0;\n    }\n\n    .ql-editor {\n      font-family: 'Sora', sans-serif !important;\n      text-align: justify;\n\n      h2 {\n        margin: 0 0 18px;\n        font-size: 38px;\n        line-height: 1.12;\n        letter-spacing: -.032em;\n        font-weight: 700;\n        color: #13231D;\n      }\n\n      h3 {\n        margin: 28px 0 14px;\n        font-size: 26px;\n        line-height: 1.22;\n        letter-spacing: -.022em;\n        font-weight: 700;\n        color: #13231D;\n      }\n\n      h4 {\n        margin: 24px 0 12px;\n        font-size: 22px;\n        line-height: 1.28;\n        letter-spacing: -.015em;\n        font-weight: 700;\n        color: #20362D;\n      }\n\n      p,\n      li {\n        font-size: 18px;\n        line-height: 1.8;\n        color: #3E4B45;\n      }\n\n      p {\n        margin: 0 0 20px;\n      }\n\n      ul,\n      ol {\n        margin: 0 0 24px 1.2em;\n        padding: 0;\n      }\n\n      li+li {\n        margin-top: 10px;\n      }\n\n      blockquote {\n        margin: 30px 0;\n        padding: 26px 28px;\n        border-left: 4px solid #D6A640;\n        background: rgba(130, 177, 148, .08);\n        border-radius: 20px;\n\n        p {\n          margin: 0;\n          font-size: 22px;\n          line-height: 1.65;\n          font-weight: 600;\n          color: #20362D;\n        }\n      }\n    }\n  }\n\n  .ql-container.ql-snow,\n  .ql-toolbar.ql-snow {\n    border: 1px solid #d1d5db;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
